













































































































































































import {Vue, Component, Prop, Ref} from 'vue-property-decorator'
import GenericTemplate from '@/pages/Pages/Templates/GenericTemplate.vue';
import {SmsTextInputWings} from '@/components/SMS';
import {MsgTransports} from '@/store/types';
import {EmailTemplateItemImpl} from '@/store/settings/templates/types';
import {notifyError} from '@/utils/notify-helper';
import {readFileAsBinary} from "@/utils/download-helper"
import EmailPreviewDialog from "@/components/Email/EmailPreviewDialog.vue";
import {SelectWings, InputWings} from "wings-ui-components";

Component.registerHooks([
  'beforeRouteLeave',
]);
@Component({
  components: {
    EmailPreviewDialog,
    GenericTemplate,
    SmsTextInputWings,
    SelectWings,
    InputWings
  }
})
export default class EmailTemplate extends Vue {
  @Prop() moderation!: boolean;
  @Ref('genericTemplate') genericTemplate: any;
  @Ref('ckeditor') ckeditor: any;

  private transport: MsgTransports = MsgTransports.EMAIL;
  private templateObject: EmailTemplateItemImpl = new EmailTemplateItemImpl();

  private fileSizeLimit = 26214400 /* 25 Megabyte */
  private tagRule: object = {
    indent: true,
    breakBeforeOpen: false,
    breakAfterOpen: false,
    breakBeforeClose: false,
    breakAfterClose: false
  }
  private editorConfig: object = {
    allowedContent: true,
    fullPage: true,
    language: this.$i18n.locale,
  }
  private editorUrl = `${process.env.BASE_URL}ckeditor/ckeditor.js`;

  private isShowEmailPreview = false;
  private emailContent: any = '';

  specialUnsubscribeRuleList: string[] = [
    'do-not-unsubscribe',
    'all',
    'template',
    'message-type',
  ]
  unsubscribeRuleList: string[] = [
    'all',
    'template',
    'message-type',
  ]
  subscribeRuleList: string[] = [
    'all',
    'template',
    'message-type',
  ]

  showEmailPreview() {
    this.emailContent = this.templateObject.message
    this.isShowEmailPreview = true
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    this.genericTemplate.beforeLeave(to, from, next)
  }

  onEditorReady(ev: any) {
    ev.dataProcessor.writer.setRules('p', this.tagRule);
    ev.dataProcessor.writer.setRules('span', this.tagRule);
    ev.dataProcessor.writer.setRules('div', this.tagRule);
    ev.insertText('');
    this.genericTemplate.templateSaved.message = this.genericTemplate.template.message;
  }

  onEditorInput(ev: any) {
    this.ckeditor.instance.insertText(ev);
  }

  selectFile() {
    const fileInputElement: any = this.$refs.file;
    fileInputElement?.click();
  }

  async onSelectAttach(e: any) {
    const files = e.target.files || e.dataTransfer.files;
    if (!files.length) return

    let fileSizes: number = this.genericTemplate.template.attached_files
          .map((f: any) => f.base64)
          .map((f: any) => f.length * (3 / 4) - 2)
          .reduce((a: number, b: number) => a + b, 0)

    this.$store.commit("setLoading", true);
    for (const file of files) {
      fileSizes += file.size
      if (fileSizes >= this.fileSizeLimit) {
        notifyError(null, null, this.$t('emailAttachedFilesSizeLimit', {filename: file.name}).toString())
        this.$store.commit("setLoading", false);
        return
      }
      this.genericTemplate.template.attached_files?.push({
        name: file.name,
        base64: btoa(await readFileAsBinary(file)),
      });
      this.$store.commit("setLoading", false);
    }
  }

  onLoadTemplate(status: string) {
    if (this.moderation) {
      this.$emit('onLoadTemplate', status)
    }
  }

  onDeleteAttach(file: any) {
    this.genericTemplate.template.attached_files =
        this.genericTemplate.template.attached_files?.filter((att: any) => att.name !== file.name)
  }

  onUnsubscribeLinksRegex(val: string) {
   if (!val) this.genericTemplate.template.unsubscribe_rule = undefined;
  }

  onSubscribeLinksRegex(val: string) {
    if (!val) this.genericTemplate.template.subscribe_rule = undefined;
  }
}
